<div
  class="cb-battle-tie"
  #container
  [class.nuclear]="battle().mode === 'nuclear'"
  [class.equity]="battle().mode === 'equity'"
  [class.crazy]="battle().mode === 'crazy'"
  [class.normal]="battle().mode === 'normal'"
>
  <div class="cb-battle-tie__roll roll" #roll>
    @for (item of options(); track $index) {
    <div
      class="cb-battle-tie__part"
      [class.team]="battle().type === 'team'"
      [class.regular]="battle().type === 'ffa'"
    >
      <div class="cb-battle-tie__part-avatars">
        @for (avatar of item?.avatars; track $index) {
        <img
          class="cb-battle-tie__part-avatar"
          width="94"
          height="94"
          [src]="avatar"
        />
        }
      </div>
      @if (showResults() && $index === battleSettings().WIN_INDEX) {
      <div class="cb-battle-tie__part-name" @fadeInAnimation>
        {{ item?.name }}
      </div>
      }
    </div>
    }
  </div>
</div>
